(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-customer-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tc-ugc-carousel')) {
    class TcUgcCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.track = this.querySelector('.tc-ugc-carousel__track');
        this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (!this.track || this.cards.length < 2) return;

        if (this.previousButton) {
          this.previousButton.hidden = false;
          this.previousButton.addEventListener('click', () => this.move(-1));
        }

        if (this.nextButton) {
          this.nextButton.hidden = false;
          this.nextButton.addEventListener('click', () => this.move(1));
        }

        this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);
        this.updateButtons();

        this.addEventListener('shopify:block:select', (event) => {
          const selectedCard = event.target.closest('[data-carousel-card]');
          if (selectedCard) {
            selectedCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      }

      requestUpdate() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateButtons());
      }

      getScrollAmount() {
        const firstCard = this.cards[0];
        if (!firstCard) return this.track.clientWidth;

        const trackStyles = window.getComputedStyle(this.track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width;

        if (this.dataset.scrollStep === 'page') {
          const cardsPerPage = Math.max(1, Math.floor(this.track.clientWidth / (cardWidth + gap)));
          return (cardWidth + gap) * cardsPerPage;
        }

        return cardWidth + gap;
      }

      move(direction) {
        const rtlMultiplier = document.documentElement.dir === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: direction * this.getScrollAmount() * rtlMultiplier,
          behavior: 'smooth'
        });
      }

      updateButtons() {
        if (!this.previousButton || !this.nextButton) return;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const currentScroll = Math.abs(this.track.scrollLeft);
        const hasOverflow = maxScroll > 2;

        this.previousButton.disabled = !hasOverflow || currentScroll <= 2;
        this.nextButton.disabled = !hasOverflow || currentScroll >= maxScroll - 2;
      }
    }

    customElements.define('tc-ugc-carousel', TcUgcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
